import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import CarouselChild from '../Carousel/CarouselChild';
import CarouselContainer from '../Carousel/CarouselContainer';
import Image from '../Image';
import SectionWithTitle from '../SectionWithTitle';
import Testimonial from '../Testimonial/Testimonial';

var TestimonialsSection = function TestimonialsSection(props) {
  var backgroundImage = props.backgroundImage,
      testimonials = props.testimonials,
      heading = props.heading,
      rest = _objectWithoutPropertiesLoose(props, ["backgroundImage", "testimonials", "heading"]);

  if (!(testimonials !== null && testimonials !== void 0 && testimonials.length)) return null;
  return /*#__PURE__*/React.createElement(SectionWithTitle, Object.assign({
    bgImage: /*#__PURE__*/React.createElement(Image, {
      image: backgroundImage,
      position: "absolute",
      top: "0",
      overflow: "hidden" // for the blur filter
      ,
      withOverlay: true,
      style: {
        filter: 'blur(3px)',
        width: '100%',
        height: '100%'
      }
    }),
    heading: heading,
    fullWidth: true,
    headerFontColor: "white",
    position: "relative"
  }, rest), /*#__PURE__*/React.createElement(CarouselContainer, {
    interval: 5000
  }, testimonials === null || testimonials === void 0 ? void 0 : testimonials.map(function (testimonial) {
    var _testimonial$acfTesti, _testimonial$acfTesti2, _testimonial$acfTesti3, _testimonial$acfTesti4;

    return /*#__PURE__*/React.createElement(CarouselChild, {
      key: testimonial === null || testimonial === void 0 ? void 0 : testimonial.id,
      width: {
        base: 335,
        md: 500,
        xl: 800
      }
    }, /*#__PURE__*/React.createElement(Testimonial, {
      author: testimonial === null || testimonial === void 0 ? void 0 : (_testimonial$acfTesti = testimonial.acfTestimonial) === null || _testimonial$acfTesti === void 0 ? void 0 : _testimonial$acfTesti.name,
      content: testimonial === null || testimonial === void 0 ? void 0 : (_testimonial$acfTesti2 = testimonial.acfTestimonial) === null || _testimonial$acfTesti2 === void 0 ? void 0 : _testimonial$acfTesti2.review,
      date: testimonial === null || testimonial === void 0 ? void 0 : (_testimonial$acfTesti3 = testimonial.acfTestimonial) === null || _testimonial$acfTesti3 === void 0 ? void 0 : _testimonial$acfTesti3.date,
      title: testimonial === null || testimonial === void 0 ? void 0 : (_testimonial$acfTesti4 = testimonial.acfTestimonial) === null || _testimonial$acfTesti4 === void 0 ? void 0 : _testimonial$acfTesti4.title,
      mx: "auto"
    }));
  })));
};

export default TestimonialsSection;